var _mask, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 900,
    viewBox: "0 0 1440 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 900
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440V900H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-466.87 -194.109C-421.414 -293.456 -291.454 -312.698 -191.153 -356.01C-100.582 -395.12 -11.4979 -438.253 87.0319 -433.294C191.819 -428.019 296.343 -396.608 375.287 -327.498C456.331 -256.55 502.709 -155.424 524.853 -50.0132C547.478 57.688 564.848 181.507 501.053 271.182C438.978 358.44 303.547 336.236 211.34 390.688C112.808 448.874 62.4839 594.144 -51.8903 597.715C-165.966 601.277 -258.091 498.883 -326.44 407.48C-387.618 325.666 -385.789 219.617 -409.012 120.134C-433.831 13.812 -512.296 -94.8277 -466.87 -194.109Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-490.487 -351.419C-434.161 -445.033 -302.862 -449.558 -198.332 -481.331C-103.941 -510.022 -10.5768 -542.878 86.7726 -526.885C190.304 -509.875 290.64 -466.923 361.322 -389.386C433.886 -309.784 468.614 -204.089 478.779 -96.8587C489.165 12.7021 492.52 137.689 419.057 219.632C347.576 299.366 215.495 262.093 117.755 305.845C13.3122 352.597 -53.0079 491.296 -167.06 482C-280.814 472.728 -360.857 360.635 -418.508 262.135C-470.111 173.967 -456.383 68.7951 -468.287 -32.6675C-481.008 -141.104 -546.775 -257.868 -490.487 -351.419Z",
    fill: "url(#paint1_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1211.18 -705.532C1328.8 -726.117 1426.61 -620.988 1527.73 -557.477C1619.05 -500.128 1713.06 -446.608 1769.61 -354.799C1829.75 -257.16 1866.19 -143.57 1852.84 -29.6742C1839.13 87.2526 1776.78 191.647 1695.56 276.869C1612.57 363.943 1511.81 456.265 1391.54 454.344C1274.51 452.475 1210.64 316.752 1104.5 267.429C991.076 214.723 829.079 259.362 755.033 158.566C681.18 58.033 716.348 -88.347 756.34 -206.507C792.137 -312.271 888.779 -376.298 963.995 -458.821C1044.38 -547.016 1093.63 -684.961 1211.18 -705.532Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1338.23 -824.221C1457.42 -831.466 1542.81 -716.018 1636.16 -641.552C1720.45 -574.31 1807.86 -510.571 1853.74 -412.992C1902.54 -309.215 1925.99 -192.252 1899.93 -80.5764C1873.18 34.071 1799.49 130.802 1709.21 206.363C1616.97 283.566 1506.48 363.988 1387.19 348.572C1271.11 333.572 1222.89 191.535 1122.96 130.603C1016.17 65.4926 850.184 91.6565 787.927 -16.8178C725.832 -125.009 777.216 -266.514 830.226 -379.435C877.675 -480.51 980.896 -533.277 1064.9 -606.831C1154.69 -685.44 1219.12 -816.982 1338.23 -824.221Z",
    fill: "url(#paint3_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.214 620.985C651.544 590.343 772.406 708.754 894.896 777.997C1005.5 840.524 1119.08 898.394 1190.65 1003.38C1266.77 1115.03 1315.85 1246.74 1306.34 1381.53C1296.58 1519.91 1228.88 1646.19 1137.92 1750.93C1044.99 1857.95 931.421 1972.11 789.75 1976.41C651.899 1980.59 569.317 1824.31 441.691 1772.04C305.312 1716.19 117.064 1777.56 24.4113 1662.96C-67.9997 1548.65 -34.5859 1374.43 6.04615 1233.17C42.4156 1106.73 152.679 1026.09 236.714 924.858C326.525 816.664 376.977 651.607 514.214 620.985Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.364 619.136C440.693 588.493 561.556 706.904 684.045 776.148C794.652 838.674 908.232 896.544 979.801 1001.53C1055.92 1113.18 1105 1244.89 1095.49 1379.68C1085.73 1518.06 1018.03 1644.34 927.069 1749.08C834.136 1856.1 720.571 1970.26 578.9 1974.56C441.048 1978.74 358.467 1822.46 230.841 1770.19C94.4612 1714.34 -93.7867 1775.71 -186.439 1661.11C-278.85 1546.8 -245.436 1372.58 -204.804 1231.32C-168.435 1104.88 -58.1715 1024.24 25.8636 923.008C115.675 814.814 166.126 649.758 303.364 619.136Z",
    fill: "url(#paint5_linear)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 29.5012,
    y1: 598.481,
    x2: 16.1059,
    y2: 321.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5889FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5889FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 160.137,
    y1: 299.912,
    x2: 155.819,
    y2: 57.9982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5889FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5889FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 804.747,
    y1: 232.343,
    x2: 1045.62,
    y2: 48.9502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5889FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5889FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 1154.55,
    y1: 165.099,
    x2: 1369.74,
    y2: 11.3979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5889FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#5889FF",
    stopOpacity: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 1001.45,
    y1: 805.986,
    x2: 527.555,
    y2: 867.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5889FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5889FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 572.5,
    y1: 718,
    x2: 498.5,
    y2: 972.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5889FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5889FF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.fc2f2c14.svg";
export { ForwardRef as ReactComponent };